<div #overlay class="overlay">
    <div class="content center-content">
        <div class="column-flex">
            <div class="title-wrapper">
                <ng-container *ngIf="!isEditing">
                    <div class="form-label" data-cy="shipyard-modal-new-shipyard-header">
                        {{ 'shipyard.create.dialog.label' | translate }}
                    </div>
                </ng-container>
                <ng-container *ngIf="isEditing">
                    <div class="form-label" data-cy="shipyard-modal-edit-shipyard-header">
                        {{ 'shipyard.edit.dialog.label' | translate }}
                    </div>
                </ng-container>
                <div data-cy="shipyard-modal-cancel-button" class="cancel button" (click)="clearForm()">
                    {{ 'shipyard.create.dialog.form.button.cancel' | translate }}
                </div>
            </div>

            <div class="body-wrapper">
                <div class="subtitle-text">
                    <div data-cy="shipyard-modal-body-text">
                        {{ 'shipyard.edit.dialog.subtitle' | translate }}
                    </div>
                    <mat-icon
                        (click)="showInfoContainer = !showInfoContainer; $event.stopPropagation()"
                        svgIcon="info"
                        class="info-icon"
                        data-cy="shipyard-modal-tooltip" />
                    <div class="info-container" *ngIf="showInfoContainer" #infoContainer>
                        <div data-cy="shipyard-modal-tooltip-text1">
                            {{ 'shipyard.create.dialog.info.1' | translate }}
                        </div>
                        <div data-cy="shipyard-modal-tooltip-text2">
                            {{ 'shipyard.create.dialog.info.2' | translate }}
                        </div>
                        <div data-cy="shipyard-modal-tooltip-text3">
                            {{ 'shipyard.create.dialog.info.3' | translate }}
                        </div>
                    </div>
                </div>
                <form class="input-form">
                    <div class="input-container">
                        <app-input-select-with-error
                            #shipyardNameInput
                            class="wider-input"
                            data-cy="shipyard-modal-name-field"
                            [initialValue]="shipyardName"
                            [legend]="'shipyard.create.dialog.form.name'"
                            [propertyName]="'name'"
                            [validatorFunction]="validatorFunction()"
                            [optionsArray]="iAPICompanyNames"
                            [maxLength]="50"
                            [placeholder]="'shipyard.create.dialog.form.shipyard'"
                            [emitOnInput]="true"
                            (onInputUpdated)="shipyardName = $event"></app-input-select-with-error>
                    </div>
                    <ng-container *ngIf="nameIsRepeated">
                        <div class="error-message" data-cy="shipyard-modal-error-message">
                            {{ 'errors.validation.generic.repeated' | translate }}
                        </div>
                    </ng-container>
                </form>
            </div>

            <div class="buttons-container">
                <div
                    class="create button"
                    data-cy="shipyard-modal-create-button"
                    (click)="createShipyard()"
                    [ngClass]="{ button_disabled: isCreateDisabled() }"
                    *ngIf="!isEditing">
                    {{ 'shipyard.create.dialog.form.button.create' | translate }}
                </div>
                <div
                    class="create button"
                    data-cy="shipyard-modal-save-button"
                    (click)="updateShipyard()"
                    [ngClass]="{ button_disabled: isCreateDisabled() }"
                    *ngIf="isEditing">
                    {{ 'shipyard.create.dialog.form.button.update' | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
